export const OPTION_HEIGHT = 40;
export const OPTIONS_PER_VIEW = 4;
